import styled from 'styled-components';
import Colors from '../../../../shared/assets/style/default/color';
import Screen from '../../../../shared/utils/screen';

const DetailAddonInfoContainer = styled.div<React.CSSProperties>`
  position: fixed;
  left: ${Screen.widthRatio * 33}5px;
  top: ${Screen.widthRatio * 649}px;
  background: ${Colors.modal.button.text};
  width: 100%;
  height: ${Screen.widthRatio * 432}px;
  left: 0;
  padding-top: ${Screen.widthRatio * 26}px;
`;

export default DetailAddonInfoContainer;
